import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import MetaData from '../layout/MetaData';
import UserLayout from '../layout/UserLayout';
import { useUpdateProfileMutation } from '../../redux/api/userApi';
import toast from 'react-hot-toast';
import '../../css/Profile.css';

const UpdateProfile = () => {
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [updateProfile, { isLoading, error, isSuccess }] = useUpdateProfileMutation();

  useEffect(() => {
    if (user) setName(user.name || '');
    if (error) toast.error(error?.data?.message);
    if (isSuccess) {
      toast.success('Profile updated successfully');
      navigate('/me/profile');
    }
  }, [user, error, isSuccess, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    updateProfile({ name });
  };

  return (
    <UserLayout>
      <MetaData title="Update Profile" />
      <div className="row wrapper">
        <div className="col-10 col-lg-8">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h2 className="mb-4 text-center">Update Profile</h2>

            <div className="mb-4">
              <label htmlFor="name_field" className="form-label">Full Name</label>
              <input
                type="text"
                id="name_field"
                className="form-control"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your full name"
                required
              />
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-primary w-100 py-2" disabled={isLoading}>
                {isLoading ? 'Updating...' : 'Update Profile'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </UserLayout>
  );
};

export default UpdateProfile;